
		import React from 'react';
    import { hydrateRoot } from 'react-dom/client';
    import { App } from '/home/runner/work/monorepo/monorepo/packages/web-video/src/client/App.tsx';
    import { VideoPage } from '/home/runner/work/monorepo/monorepo/packages/web-video/src/client/pages/VideoPage.tsx';

    const initialComponentProps = __SSR_DATA__.props;
    const lang = __SSR_DATA__.lang;

    const root = document?.getElementById('root');
    if (root) {
      hydrateRoot(
        root,
        React.createElement(
            App,
            { defaultLang: lang },
            React.createElement(VideoPage, initialComponentProps)
       )
      );
    } else {
      throw new Error('Root element not found while hydrating component VideoPage');
    }
	